module.exports = __webpack_public_path__ + "static/media/kids.23e9b871.jpg";